<ng-container *ngIf="!(loading$ | async)">
    <ng-container *ngIf="portalId$ | async as portalId; else noPortalFound">
        <section *ngIf="json$ | async as json">
            <div class="container">
                <h1 [innerHTML]="headline$ | async"></h1>
                <p [innerHTML]="json.Text"></p>
            </div>
        </section>
    </ng-container>
    <ng-template #noPortalFound>
        <section>
            <div class="container">
                <h1>An error occured</h1>
                <div class="large">
                    <p *ngIf="errorMessage">{{ errorMessage }}</p>
                </div>
            </div>
        </section></ng-template
    >
</ng-container>
